import CarouselPromo from "./CarouselPromo";
export default CarouselPromo;
